import React, { useState } from "react";

const Footer = () => {

  return (
    <div className="footer">
        <div className="footer_flex">
            <div className="left">
                <p>Copyright 2025 © Bentex Suits. All rights reserved.</p>
            </div>
            <div className="right">
                <p>
                Developed by 
                <a target="_blank" href="https://securewebtechnologies.com/">Secure Web Technology</a>
              </p>

            </div>
        </div>
    </div>
  );
};

export default Footer;
